// TODO - remove becouse of legacy

import axios from 'utils/axios'
import { useMutation } from 'react-query'
import { queryClient } from 'queryClient'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { Template } from '../types'

/// ////////////////////////////////////////////////////////////////////////////////
// GRAPHQL
/// ////////////////////////////////////////////////////////////////////////////////

type QueryResponse = GraphQLResponse<'archiveTemplate', boolean>

const ARCHIVE_TEMPLATE = `
  mutation archiveTemplate($templateId: Int!) {
    archiveTemplate(templateId: $templateId)
  }
`

/// ////////////////////////////////////////////////////////////////////////////////
// FUNCTION
/// ////////////////////////////////////////////////////////////////////////////////

type ArchiveTemplate = (templateId: number) => Promise<number>

const archiveTemplate: ArchiveTemplate = async (templateId) => {
  try {
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: ARCHIVE_TEMPLATE,
      variables: {
        templateId
      }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { archiveTemplate } = data
    if (!archiveTemplate) {
      throw new Error("Can't archive template!")
    }

    return templateId
  } catch (err) {
    throw new Error(extractErrorInfo(err) as string)
  }
}

/// ////////////////////////////////////////////////////////////////////////////////
// HOOK EVENTS
/// ////////////////////////////////////////////////////////////////////////////////

type ArchiveTemplateContext = { prevTemplate?: Template }

type ArchiveTemplateEvents = {
  onMutate: (templateId: number) => Promise<ArchiveTemplateContext>
  onError: (error: string, templateId: number, context: ArchiveTemplateContext) => void
  onSettled: (templateId?: number) => void
}

const archiveTemplateEvents: ArchiveTemplateEvents = {
  onMutate: async (templateId) => {
    await queryClient.cancelQueries(['template', templateId])

    // Snapshot the previous value
    const prevTemplate = queryClient.getQueryData<Template>(['template', templateId])

    if (prevTemplate) {
      queryClient.removeQueries(['template', templateId])
    }

    return { prevTemplate }
  },
  onError: (_err, templateId, context) => {
    if (context?.prevTemplate) {
      // Restore template on any error
      queryClient.setQueryData<Template>(['template', templateId], context.prevTemplate)
    }
  },
  onSettled: (templateId: number) => {
    if (templateId) {
      queryClient.invalidateQueries(['template', templateId])
      queryClient.invalidateQueries(['templatesList'])
    }
  }
}

/// ////////////////////////////////////////////////////////////////////////////////
// HOOK
/// ////////////////////////////////////////////////////////////////////////////////

export const useArchiveTemplate = () => useMutation(archiveTemplate, archiveTemplateEvents)
